import { attach, createEvent, createStore } from 'effector';
import { createInitialEntityState, EntityState, WorkspaceMember } from '@nx-frontend/shared/types';

export type WorkspaceMembersState = EntityState<WorkspaceMember>;
export const setWorkspaceMembersStateEvent = createEvent<WorkspaceMembersState>();
export const setWorkspaceMembersEvent = createEvent<WorkspaceMember[]>();
export const upsertWorkspaceMembersEvent = createEvent<WorkspaceMember[]>();
export const deleteWorkspaceMemberEvent = createEvent<WorkspaceMember>();
export const $workspaceMembersState = createStore<WorkspaceMembersState>(createInitialEntityState())
  .on(setWorkspaceMembersStateEvent, (_, state) => {
    return { ...state };
  })
  .on(setWorkspaceMembersEvent, (state, wsMembers) => {
    const entities: Record<string, WorkspaceMember> = {};
    wsMembers.forEach((member) => {
      entities[member.globalId] = member;
    });
    return { entities, ids: Object.keys(entities) };
  })
  .on(upsertWorkspaceMembersEvent, (state, wsMembers) => {
    const entities = { ...state.entities };
    wsMembers.forEach((member) => {
      entities[member.globalId] = member;
    });
    return { ...state, entities, ids: Object.keys(entities) };
  })
  .on(deleteWorkspaceMemberEvent, (state, deletedMember) => {
    const members = Object.values(state.entities).filter((member) => member.userId !== deletedMember.userId);
    return { ...state, ...workspaceMembersToState(members) };
  });

export const $workspaceMemberUserIds = $workspaceMembersState.map((state) => {
  return Object.values(state.entities).map((member) => member.userId);
});

export const getWorkspaceMemberByUserIdFx = attach({
  source: [$workspaceMembersState],
  effect: ([workspaceMembersState]: [WorkspaceMembersState], { id }: { id: number }) => {
    const entities = workspaceMembersState.entities;
    return Object.values(entities).find((member) => member.userId === id);
  },
});

export function workspaceMembersToState(members: WorkspaceMember[]): WorkspaceMembersState {
  const entities: Record<string, WorkspaceMember> = {};
  members.forEach((member) => {
    entities[member.globalId] = member;
  });
  return { entities, ids: Object.keys(entities) };
}
